<template>
  <div
    v-if="
      user != null
    "
    class="container"
  >
    <h1 class="pb-4">Welcome {{ user.get("firstName") }}!</h1>
    <div v-if="user.get('schools').length == 0">
      <p>It doesn't look like you are connected to a school. What would you like to do?</p>
      <button
          class="btn btn-lg btn-primary mt-4"
          data-toggle="modal"
          data-target="#createNewSchoolModal"
        >
          Create a School
          <p class="mb-0 small">
            Setup a new account if you are creating an account for yourself or
            your team
          </p>
        </button>
        <h5 class="mt-4">or</h5>
        <button
          class="btn btn-lg btn-primary mt-4"
          data-toggle="modal"
          data-target="#joinSchoolModal"
        >
          Enter a Code to Join a School
          <p class="mb-0 small">
            Someone who is already part of a school can give you the code to join their school
          </p>
        </button>
    </div>
    <div v-else>
      <div v-if="students.length == 0" class="pb-4">
        <h3>It doesn't look like you have any students created yet.</h3>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="row mb-2">
          <div class="col">
            <button class="btn btn-primary" v-on:click="showAddStudentModal()">Add a Student</button>
          </div>
          <div class="col">
            <button class="btn btn-primary" v-on:click="showAddMultiServiceMinutesModal()">Add Service Minutes</button>
          </div>
        </div>
          <h4>Starred Students</h4>
          <div class="row">
            <StudentRow
                  v-for="student in students.filter(s =>
                    starredStudents.some(
                      ss => ss == s.id
                    )
                  ).sort($orderByParseName)"
                  :key="student.id"
                  v-bind:Student="student" 
                  v-bind:SelectedStudent="selectedStudent" 
                  v-bind:User="user" 
                  @student-selected="studentSelected"
                  @updated-stars="starredStudentsUpdated"/>
          </div>
          <div class="separatorLine"/>
          <div class="row">
            <StudentRow
                  v-for="student in students.filter(s =>
                    !starredStudents.some(
                      ss => ss == s.id
                    )
                  ).sort($orderByParseName)"
                  :key="student.id"
                  v-bind:Student="student" 
                  v-bind:SelectedStudent="selectedStudent" 
                  v-bind:User="user" 
                  @student-selected="studentSelected"
                  @updated-stars="starredStudentsUpdated"/>
          </div>

        </div>
        <div class="col-6">
          <p class="mt-4" v-if="selectedStudent == null">Select a student to see their service minutes</p>
          <div v-else>
            <div class="row mb-2">
              <div class="col">
                <button class="btn btn-primary" v-on:click="showAllServiceMinutes">Generate Report</button>
              </div>
            </div>
            <div class="row">
              <div class="col-auto pr-0 mt-2 h3">
                <span class="material-icons btn-link pointer" v-on:click="editStudent(selectedStudent)">
                  edit
                </span>
              </div>
              <div class="col-auto pl-1">
                <h3 class="mt-2">{{selectedStudent.get("name")}}</h3>
              </div>
              <div class="col"></div>
              <div class="col-auto" align="center">
                <button class="btn btn-primary" v-on:click="showAddServiceMinutesModal()">Add {{ selectedStudent.get("name") }}'s Minutes</button>
              </div>
            </div>    
            
            <div v-for="(minutes, serviceId) in groups" :key="serviceId">
              <StudentServiceRow
              v-bind:Student="selectedStudent"
              v-bind:Service="services.find(s => s.id == serviceId)"
              v-bind:Minutes="minutes"
              @edit-minutes="editMinutes"
              @see-service-minutes="showStudentService" />              
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="schools.length > 0" class="row">
      <div class="col">
        <h3 class="pt-4">Schools</h3>
        <div class="separatorLine mb-4"/>
      </div>
    </div>
    <div class="row" v-for="school in schools" :key="school.id">
      <div class="col-auto">
        <h4>{{school.get("name")}}</h4>
      </div>
      <div class="col" />
      <div class="col-auto">
        <h4>Join Code: {{school.get("joinCode")}}</h4>
      </div>
    </div>

    <AddStudentModal
      v-if="loaded"
      v-bind:Schools="schools"
      v-bind:Services="services"
      @student-added="loadStudents"
    />
    <EditStudentModal
      v-if="loaded"
      v-bind:Schools="schools"
      v-bind:Services="services"
      v-bind:StudentToEdit="studentToEdit"
      @student-updated="loadStudents"
    />
    <AddServiceMinutesModal
      v-bind:User="user"
      v-bind:Student="selectedStudent"
      v-bind:Services="services"
      @service-minutes-added="studentSelected"
    />
    <AddMultiServiceMinutesModal
      v-bind:User="user"
      v-bind:Students="students"
      v-bind:Services="services"
      @service-minutes-added="studentSelected(selectedStudent)"
    />
    <EditServiceMinutesModal
      v-bind:Minutes="minutesToEdit"
      v-bind:Student="selectedStudent"
      v-bind:Services="services"
      @service-minutes-updated="studentSelected"
    />
    <CreateNewSchoolModal
      @school-created="loadData"
    />
    <JoinSchoolModal
      @school-joined="loadData"
    />
    <AllServiceMinutesModal
      v-bind:SelectedStudent="selectedStudent"
      v-bind:Services="services"
    />

    <div class="row pb-4 mt-4">
      <div class="col">
      <div class="separatorLine mb-4"/>
        <p>To download the app click the button or scan the QR code below.</p>
        <div class="row justify-content-center">
          <div class="col-auto">
            <a href="https://apps.apple.com/us/app/special-data/id1540105813?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 83px;"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1605225600&h=5cddb73cbece3ce689a60299d9f2201f" alt="Download on the App Store" style="border-radius: 13px; width: 250px; height: 83px;"></a>
          </div>
          <div class="col-auto">
            <img
              src="@/assets/qr-code.jpg"
              width="200"
              height="200"
              alt="QR Code"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Parse from "parse"
import StudentRow from "@/v2/StudentRow.vue";
import AddStudentModal from "@/v2/AddStudentModal.vue";
import EditStudentModal from "@/v2/EditStudentModal.vue";
import AddMultiServiceMinutesModal from "@/v2/AddMultiServiceMinutesModal.vue";
import AddServiceMinutesModal from "@/v2/AddServiceMinutesModal.vue";
import EditServiceMinutesModal from "@/v2/EditServiceMinutesModal.vue";
import CreateNewSchoolModal from "@/v2/CreateNewSchoolModal.vue";
import JoinSchoolModal from "@/v2/JoinSchoolModal.vue";
import StudentServiceRow from "@/v2/StudentServiceRow.vue";
import AllServiceMinutesModal from "@/v2/AllServiceMinutesModal.vue"

import $ from "jquery";

export default {
  name: "Home",
  components: {
    StudentRow,
    AddStudentModal,
    EditStudentModal,
    AddServiceMinutesModal,
    AddMultiServiceMinutesModal,
    EditServiceMinutesModal,
    CreateNewSchoolModal,
    JoinSchoolModal,
    StudentServiceRow,
    AllServiceMinutesModal
  },
  watch: {
    "$store.getters.user": async function() {
      await this.loadData();
    }
  },
  data() {
    return {
      students: [],
      schools: [],
      services: [],
      user: null,
      selectedStudent: null,
      serviceMinutes: [],
      loaded: false,
      starredStudents: [],
      minutesToEdit: null,
      studentToEdit: null,
      selectedStudentService: null,
    };
  },
  async mounted() {
    await this.loadData();
  },
  computed:{
    groups(){
      return this.groupBy(this.serviceMinutes, 'receivedService')
    }
  },
  methods: {
    async loadData() {
      this.$store.commit("updateLoading", true);
      await this.loadUser();
      if (this.user != null) {
        await this.loadStudents();
        await this.loadSchools();
        await this.loadServices();
      }
      this.loaded = true;
      this.$store.commit("updateLoading", false);
    },
    async loadUser() {
      this.user = await Parse.User.current().fetch();
      if (this.user != null) {
        this.starredStudents = this.user.get("starredStudents");
      }
    },
    async loadStudents() {
      let parseQuery = new Parse.Query("Student");
      parseQuery.ascending("name");
      this.studentToEdit = null
      this.selectedStudent = null
      this.students = await parseQuery.find();
    },
    async loadSchools() {
      let parseQuery = new Parse.Query("School");
      this.schools = await parseQuery.find();
    },
    async loadServices() {
      let parseQuery = new Parse.Query("Service");
      this.services = await parseQuery.find();
    },
    async studentSelected(student) {
      if(student != null){
        this.selectedStudent = null
        let query = new Parse.Query("ServiceMinutes")
        query.equalTo("studentId", student.id)
        query.descending("date")
        var date = new Date(), y = date.getFullYear(), m = date.getMonth()
        var firstDay = new Date(y, m, 0, 0, 0, 0, 0)
        var lastDay = new Date(y, m + 1, 0, 23, 59,59)
        query.greaterThanOrEqualTo("date", firstDay)
        query.lessThanOrEqualTo("date", lastDay)
        this.selectedStudent = student
        this.serviceMinutes = await query.find()
      }
    },
    starredStudentsUpdated() {
      this.loadUser();
    },
    showAddStudentModal() {
      $("#addStudentModal").modal("show");
    },
    showAddServiceMinutesModal() {
      $("#addServiceMinutesModal").modal("show");
    },
    showAddMultiServiceMinutesModal() {
      $("#addMultiServiceMinutesModal").modal("show");
    },
    editStudent(student){
      this.studentToEdit = student
      $("#editStudentModal").modal("show");
    },
    editMinutes(minutes){     
      this.minutesToEdit = minutes
      $("#editServiceMinutesModal").modal("show");
    },
    showStudentService(studentService){
      this.selectedStudentService = studentService
      $("#allServiceMinutesModal").modal("show");
    },
    showAllServiceMinutes(){
      $("#allServiceMinutesModal").modal("show");
    },
    groupBy(array, key){
      const result = {}
      this.selectedStudent.get("services").forEach(service => {
        result[service["service"]] = []
      })
      console.log(array)
      if(array != undefined){
      array.forEach(item => {
        if (!result[item.get(key)]){
          result[item.get(key)] = []
        }
        result[item.get(key)].push(item)
      })
    }
      return result
    }
  }
};
</script>

<style scoped></style>
